import type { NavigateFunction } from "react-router-dom";
import type { Locale } from "@project/i18n";
import { ApiRequestError } from "@apps/dashboard/lib/api-fetch";
import { acceptHouseInvitation } from "@apps/dashboard/lib/home-expense-api";
import {
  clearStoredHouseInviteToken,
  getStoredHouseInviteToken,
} from "@apps/dashboard/lib/house-invite-token";
import { dashboardPaths } from "@apps/dashboard/lib/routes";

export type AcceptStoredInviteOutcome = "navigated" | "noop" | "held";

/**
 * Tras login/registro, o al cargar el shell autenticado, acepta invitación pendiente en sessionStorage.
 */
export async function tryAcceptStoredHouseInvite(
  locale: Locale,
  navigate: NavigateFunction,
): Promise<AcceptStoredInviteOutcome> {
  const token = getStoredHouseInviteToken();
  if (!token) {
    return "noop";
  }
  try {
    const res = await acceptHouseInvitation(locale, { token });
    clearStoredHouseInviteToken();
    if (res.houseId) {
      navigate(dashboardPaths.houseMembers(res.houseId), { replace: true });
      return "navigated";
    }
    return "noop";
  } catch (err) {
    if (
      err instanceof ApiRequestError &&
      err.key === "api.errors.houses.invitationEmailMismatch"
    ) {
      return "held";
    }
    clearStoredHouseInviteToken();
    return "noop";
  }
}
